import React, { useState } from 'react';
import './AppointmentForm.css';

const AppointmentForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        serviceType: 'Naprawa silnika/skrzyni',
        message: '',
        date: ''
    });
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const sendToWhatsApp = (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !formData.phone.trim() || !formData.message.trim()) {
            setSubmitStatus({ type: 'error', message: 'Proszę wypełnić wszystkie wymagane pola (*)' });
            return;
        }

        const dateText = formData.date ? `\n📅 Preferowany termin: ${formData.date}` : '';

        const messageText = `🔧 *NOWE ZAPYTANIE ZE STRONY STREFA NAPĘDU*\n\n` +
            `👤 *Imię i nazwisko:* ${formData.name}\n` +
            `📞 *Telefon:* ${formData.phone}\n` +
            `🛠️ *Usługa:* ${formData.serviceType}\n` +
            `💬 *Wiadomość:* ${formData.message}${dateText}\n\n` +
            `📍 Strefa Napędu - ul. Kotuli 3, 35-122 Rzeszów`;

        const encodedMessage = encodeURIComponent(messageText);
        const whatsappUrl = `https://wa.me/48888329544?text=${encodedMessage}`;

        window.open(whatsappUrl, '_blank');

        setSubmitStatus({
            type: 'success',
            message: '✅ Przekierowanie do WhatsApp! Wyślij wiadomość, aby umówić wizytę.'
        });

        setTimeout(() => {
            setFormData({
                name: '',
                phone: '',
                serviceType: 'Naprawa silnika/skrzyni',
                message: '',
                date: ''
            });
            setSubmitStatus(null);
        }, 5000);
    };

    return (
        <form onSubmit={sendToWhatsApp}>
            <div className="form-group">
                <label>Imię i nazwisko *</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Jan Kowalski" required />
            </div>
            <div className="form-group">
                <label>Numer telefonu *</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="501 234 567" required />
            </div>
            <div className="form-group">
                <label>Usługa / opis problemu</label>
                <select name="serviceType" value={formData.serviceType} onChange={handleChange}>
                    <option value="Naprawa silnika/skrzyni">Naprawa silnika/skrzyni</option>
                    <option value="Serwis hybrydowej baterii">Serwis hybrydowej baterii</option>
                    <option value="Autoelektryka">Autoelektryka</option>
                    <option value="Wulkanizacja">Wulkanizacja</option>
                    <option value="Przegląd okresowy / olej">Przegląd okresowy / olej</option>
                    <option value="Inne">Inne</option>
                </select>
            </div>
            <div className="form-group">
                <label>Wiadomość (model, rocznik, objawy) *</label>
                <textarea rows="4" name="message" value={formData.message} onChange={handleChange} placeholder="Np. Toyota Auris 2012 hybryda - check engine, spadek mocy" required />
            </div>
            <div className="form-group">
                <label>Preferowana data (opcjonalnie)</label>
                <input type="text" name="date" value={formData.date} onChange={handleChange} placeholder="np. 12.06 lub poniedziałek rano" />
            </div>

            <button type="submit" className="btn-submit">
                <i className="fab fa-whatsapp"></i> Wyślij zapytanie → WhatsApp
            </button>

            {submitStatus && (
                <div className={`status-message ${submitStatus.type}`}>
                    {submitStatus.message}
                </div>
            )}

            <div className="whatsapp-note">
                <i className="fab fa-whatsapp"></i> Po wysłaniu formularza zostaniesz przekierowany do WhatsApp.
            </div>
        </form>
    );
};

export default AppointmentForm;